import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { Button, Paper, Stack, Title, Box, Flex } from "@mantine/core";
import { HSpace, McInputNew, McTextAreaNew } from "../../../../../../../components";
import {
  IGKMaalingAvOvertrykkResultater,
  IGKRapport,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../../ReportBoard/ReportDocxImageContainer";
const MaalingAvOvertrykk: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvOvertrykkResultater;
}> = ({ data, onUpdateEditData }) => {
  const addNewRow = () => {
    const newTilleggsRomResultat = {
      romNr: "",
      romNavn: "",
      prosjektertTrykkdifferanse: null,
      maaltTrykkdifferanse: null,
    };
    const updatedMaaleresultater = [...data.inndata.tilleggsRomResultater, newTilleggsRomResultat];
    onUpdateEditData("testResultater.maalingAvOvertrykkLAFTak.inndata.tilleggsRomResultater", updatedMaaleresultater);
    return updatedMaaleresultater;
  };
  const removeLastRow = () => {
    const updatedMaaleresultater = [...data.inndata.tilleggsRomResultater];
    if (updatedMaaleresultater.length > 0) {
      updatedMaaleresultater.pop(); // Remove the last element
      onUpdateEditData("testResultater.maalingAvOvertrykkLAFTak.inndata.tilleggsRomResultater", updatedMaaleresultater);
    }
  };
  const updateMaaleresultater = (resultat: string | number, i: number, parameter: string) => {
    const maaleresultater = [...data.inndata.tilleggsRomResultater];
    maaleresultater[i][parameter] = resultat;
    onUpdateEditData("testResultater.maalingAvOvertrykkLAFTak.inndata.tilleggsRomResultater", maaleresultater);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Måling av overtrykk</Title>
        <Stack gap={0}>
          <b>Hvor mange trykkforskjeller skal måles? &#40;-&#41;:</b>
          <Flex>
            <Button color="green" onClick={addNewRow}>
              Legg til rad
            </Button>
            <HSpace />
            <Button variant="danger-filled" onClick={removeLastRow}>
              Fjern siste rad
            </Button>
          </Flex>
        </Stack>
        {Number(data.inndata.tilleggsRomResultater.length) > 0 && (
          <Flex direction="column" mt="lg">
            <b>Fyll inn måleresultater:</b>
            <table>
              <thead>
                <tr>
                  <th>Romnummer &#40;-&#41;</th>
                  <th>Romnavn &#40;-&#41;</th>
                  <th>Prosjektert trykkdifferanse &#40;Pa&#41;</th>
                  <th>Målt trykkdifferanse &#40;Pa&#41;</th>
                </tr>
              </thead>
              {data.inndata.tilleggsRomResultater.map((rom, i) => (
                <tbody key={i}>
                  <tr>
                    <td>
                      <McInputNew
                        value={rom.romNr}
                        type="text"
                        onChange={(e) => updateMaaleresultater(e.target.value, i, "romNr")}
                        placeholder="Romnummer"
                      />
                    </td>
                    <td>
                      <McInputNew
                        value={rom.romNavn}
                        type="text"
                        onChange={(e) => updateMaaleresultater(e.target.value, i, "romNavn")}
                        placeholder="Romnavn"
                      />
                    </td>
                    <td>
                      <McInputNew
                        value={rom.prosjektertTrykkdifferanse}
                        normalizeNumbers={true}
                        type="text"
                        onBlur={(e) => updateMaaleresultater(Number(e.target.value), i, "prosjektertTrykkdifferanse")}
                        placeholder="Prosjektert trykkdifferanse"
                      />
                    </td>
                    <td>
                      <McInputNew
                        value={rom.maaltTrykkdifferanse}
                        normalizeNumbers={true}
                        type="text"
                        onBlur={(e) => updateMaaleresultater(Number(e.target.value), i, "maaltTrykkdifferanse")}
                        placeholder="Målt trykkdifferanse"
                      />
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
            <Box mt="lg">
              <ReportDocxImageContainer docxImageTag="maalingAvOvertrykkLAFTak" title="Målepunkter mellom rom" />
              <div style={{ width: "50%" }}>
                <McTextAreaNew
                  label="Kommentar:"
                  value={data.inndata.kommentar}
                  onChange={(e) =>
                    onUpdateEditData("testResultater.maalingAvOvertrykkLAFTak.inndata.kommentar", e.target.value)
                  }
                />
              </div>
            </Box>
          </Flex>
        )}
      </Stack>
    </Paper>
  );
};
export default MaalingAvOvertrykk;